<!-- 収集運搬業者 -->
<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h2>
          <v-icon class="mr-2">
            mdi-domain
          </v-icon>
          収集運搬業者
        </h2>
        <v-spacer class="mt-2" />
      </v-col>
    </v-row>

    <!-- 検索ブロック -->
    <v-row>
      <v-col>
        <v-expansion-panels accordion>
          <v-expansion-panel>
            <v-expansion-panel-header class="panel-header-color panel-selectable">
              <strong>
                <v-icon class="panel-header-color">
                  mdi-magnify
                </v-icon>
                &nbsp;条件を指定して検索
              </strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="name"
                        dense
                        hide-details="auto"
                        label="加入者名"
                        clearable
                        outlined
                        persistent-placeholder
                        placeholder="部分一致で検索"
                        rounded
                        @blur="searchButtonClickEvent"
                        @click:clear="name = null; searchButtonClickEvent()"
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="subscriber_number"
                        dense
                        hide-details="auto"
                        label="加入者番号"
                        clearable
                        outlined
                        persistent-placeholder
                        rounded
                        @blur="searchButtonClickEvent"
                        @click:clear="subscriber_number = null; searchButtonClickEvent()"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-checkbox
                        v-model="withoutInvisible"
                        dense
                        label="非表示を表示しない"
                        persistent-hint
                        @change="searchButtonClickEvent()"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="primary" @click="searchButtonClickEvent">
                    <v-icon>mdi-magnify</v-icon>&nbsp;検索
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <!-- /検索ブロック -->

    <v-row
      v-if="!isDemoEnv"
    >
      <v-col class="text-right">
        <v-btn color="info" @click="exportButtonClickEvent">
          <v-icon>mdi-file-download-outline</v-icon>&nbsp;CSV出力
        </v-btn>
        &nbsp;
        <v-btn color="info" @click="importButtonClickEvent" :disabled="isJwMode">
          <v-icon>mdi-file-upload-outline</v-icon>&nbsp;CSV取込
        </v-btn>
        &nbsp;
        <v-btn
          color="primary"
          :disabled="isJwMode"
          @click="addSubscriberButtonClickEvent"
        >
          収集運搬業者の追加&nbsp;<v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>


    <v-row>
      <v-col>
        <v-card class="rounded-card" flat>
          <v-card-text>
            <v-data-table
              :headers="tableHeaders"
              :items="transports"
              disable-pagination
              :items-per-page="-1"
              disable-sort
              hide-default-footer
            >
              <template v-slot:[`item.name`]="{ item }">
                <div style="display: flex; align-items: center; gap: 4px;">
                  <v-img
                    v-if="item.use_station"
                    max-height="18"
                    max-width="18"
                    :src="require(`@/assets/images/DXE_mark.svg`)"
                  />
                  <span :title="item.name" class="line-clamp one-clamp">{{ item.name }}</span>
                </div>
              </template>
              <template v-slot:[`item.address`]="{ item }">
                <span class="line-clamp one-clamp">{{ item.address }}</span>
              </template>
              <template v-slot:[`item.invisible`]="{item}">
                {{ item.invisible ? '非表示' : '' }}
              </template>
              <template v-slot:[`item.editable`]="{item}">
                <v-btn
                  :icon="$vuetify.breakpoint.mdAndUp"
                  :text="$vuetify.breakpoint.smAndDown"
                  :color="`info ${$vuetify.breakpoint.mdAndUp ? 'darken-2': null}`"
                  @click="showButtonClickEvent(item)"
                >
                  <v-icon v-if="$vuetify.breakpoint.mdAndUp">
                    mdi-file-document-outline
                  </v-icon>
                  <span v-else>参照</span>
                </v-btn>
                <v-btn
                  v-if="item.can_remove && !isDemoEnv"
                  :disabled="isJwMode"
                  :icon="$vuetify.breakpoint.mdAndUp"
                  :text="$vuetify.breakpoint.smAndDown"
                  :color="`error ${$vuetify.breakpoint.mdAndUp ? 'darken-2': null}`"
                  @click="deleteButtonClickEvent(item)"
                >
                  <v-icon v-if="$vuetify.breakpoint.mdAndUp">
                    mdi-trash-can-outline
                  </v-icon>
                  <span v-else>削除</span>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- ページャ -->
    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>
    <!-- /ページャ -->

    <!-- /ダイアログ -->
    <subscriber-edit-dialog
      :enable-dialog="enableSubscriberDialog"
      :dialog-type="dialogType"
      @closeEvent="closeSubscriberDialog"
      @registerEvent="subscriberCallback"
    />
    <!-- ダイアログ -->

    <!-- アップグレード誘導モーダル -->
    <trial-plan-guide-dialog
      :enable-dialog="enableTrialPlanGuideDialog"
      :from-emission="true"
      @closeCallback="dialogCloseCallback"
    />

    <confirm ref="confirm" />
  </v-container>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import Confirm from '../../../../components/Confirm'
import SubscriberEditDialog from '../../../../components/SubscriberEditDialog'
import DownloadMixin from '../../../../mixins/download-mixin'
import CustomPagination from "@/driver/components/_CustomPagination.vue";
import TrialPlanGuideDialog from '../../dialogs/_TrialPlanGuideDialog'

export default {
  name: 'DriverMasterTransportIndex',
  components: {
    CustomPagination,
    Confirm,
    SubscriberEditDialog,
    TrialPlanGuideDialog
  },
  filters: {
  },
  mixins: [
    DownloadMixin,
  ],
  data () {
    return {
      page: 1,
      perPage: 50,
      totalVisible: 7,
      name: null,
      subscriber_number: null,  // 加入者番号
      enableSubscriberDialog: false,
      dialogType: 'transport',
      tableHeaders: [
        { value: 'subscriber_number', text: '加入者番号' },
        { value: 'confirmation_number', text: '公開確認番号' },
        { value: 'name', text: '加入者名' },
        { value: 'zip_code', text: '郵便番号' },
        { value: 'address', text: '住所' },
        { value: 'invisible', text: '非表示' },
        { text: '詳細', value: 'editable', align: 'end' },
      ],
      transports: [],
      enableTrialPlanGuideDialog: false,
      withoutInvisible: true,
    }
  },
  computed: {
    ...mapState('DriverMasterTransport', {
      pagination: 'pagination',
      searchCondition: 'condition',
    }),
    ...mapState('DriverTenantConfiguration', {
      isJwMode: 'use_jw_mode',
      isTrialPlan: 'use_trial_plan',
    }),
    ...mapGetters('DriverAuthentication', [
      'isDemoEnv',
    ]),
    ...mapGetters('DriverMasterTransport', [
      'hasResult'
    ]),
  },
  watch: {
  },
  created() {
    if (this.$route.params.resetCondition) {
      this.resetState()
    }
    this.name = this.searchCondition.name
    this.subscriber_number = this.searchCondition.subscriber_number
    this.withoutInvisible = this.searchCondition.without_invisible
    this.page = this.pagination.current_page
    this.perPage = this.searchCondition.limit
    this.searchTransports()
  },
  methods: {
    ...mapActions('DriverMasterTransport', {
      fetchTransports: 'index',
      deleteTransport: 'destroy',
      resetState: 'resetState',
      checkCount: 'check',
    }),
    /**
     * 検索ボタン クリックイベント
     */
    searchButtonClickEvent () {
      this.page = 1
      this.searchTransports()
    },
    /**
     * 追加ボタン クリックイベント
     */
    addSubscriberButtonClickEvent () {
      if (this.isTrialPlan) {
        this.checkCount().then((content) => {
          if (content.pagination.total_count < 10) {
            this.enableSubscriberDialog = true
          } else {
            this.enableTrialPlanGuideDialog = true
          }
        })
      } else {
        this.enableSubscriberDialog = true
      }
    },
    /**
     * 削除ボタン クリックイベント
     * @param item { Object }
     */
    deleteButtonClickEvent (item) {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteTransport({ id: item.id }).then(() =>{
            this.searchTransports()
          })
        }
      })
    },
    /**
     * モーダルを閉じる
     */
    closeSubscriberDialog () {
      this.enableSubscriberDialog = false;
    },
    /**
     * モーダルからのコールバック処理
     */
    subscriberCallback (forms) {
      this.closeSubscriberDialog()
      this.searchTransports()
    },
    /**
     * 参照ボタンクリックイベント
     */
    showButtonClickEvent (item) {
      this.$router.push({name: 'DriverMasterTransport', params: { id: item.id }})
    },
    changePage(page) {
      this.page = page;
      this.searchTransports()
    },
    changePerPage (perPage) {
      this.perPage = perPage
      this.page = 1
      this.searchTransports()
    },
    /**
     * CSV出力ボタン クリックイベント
     */
    exportButtonClickEvent() {
      let params = this.buildParam('csv')
      this.fetchTransports(params).then((content) => {
        this.downloadCsv(content, 'driver収集運搬業者')
      })
    },
    /**
     * CSV取込ボタン クリックイベント
     */
    importButtonClickEvent() {
      this.$router.push({name: 'DriverMasterTransportCsvImport'})
    },
    /**
     * 収集運搬業者検索
     */
    searchTransports () {
      let params = this.buildParam('json')
      this.fetchTransports(params).then((content) => {
        this.transports = content.transports
      })
    },
    /*パラメータ設定 */
    buildParam(format) {
      return {
        name: this.name,
        subscriber_number: this.subscriber_number,
        without_invisible: this.withoutInvisible,
        page: this.page,
        limit: this.perPage,
        format: format
      }
    },
    /**
     * ダイアログ 閉じるボタンコールバック
     */
     dialogCloseCallback() {
      this.enableTrialPlanGuideDialog = false;
    },

  }
}
</script>

<style scoped lang="scss">
.panel-header-color {
  color: #0D74BA !important;
  & .v-expansion-panel-header__icon {
    & .v-icon {
      color: #0D74BA !important;
      &::before {
        color: #0D74BA !important;
      }
    }
  }
}
.panel-selectable {
  background-color: #DCE7EB;
}

</style>
